export default "__VITE_ASSET__DufLAu8n__"